/*
How to use:
*createDynamicComponent:
  params: {
    必要:
      component: 欲生成元件的主體
      props: 欲生成元件的 props
  }
＊mountDynamicComponent：
  params: {
    必要:
      mountHandle: observer 裡的操作, 這裡我會給你 mutations(DOM tree) - Function(mutations)
  }
*removeObserver: 移除監聽器

Description: 動態掛載元件用
*/

import Vuetify from 'vuetify'
import Vue from 'vue'

const vuetify = new Vuetify()
let observer = null

// 建立元件實例
const createDynamicComponent = (component, props) => {
  const component_ex = Vue.extend(component)
  const component_main = new component_ex({
    vuetify,
    propsData: props,
  })
  component_main.$mount()
  return component_main
}

// 開始監聽 DOM tree 並掛載
const mountDynamicComponent = (mountHandle) => {
  observer = new MutationObserver((mutations) => {
    // 掛載條件
    mountHandle(mutations)
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  })
}

const removeObserver = () => {
  if (observer) {
    observer.disconnect()
    observer = null
  }
}

export { mountDynamicComponent, removeObserver, createDynamicComponent }
